// Module
var code = `<h2 class="deck-compare-title">{{copy}}</h2>
<div class="deck-compare-columns">
  {{#listItems}}
  <div class="deck-compare-column deck-compare-column--{{attrColumn}}">
    <p class="deck-compare-label">{{label}}</p>
    <p class="deck-compare-copy">{{copy}}</p>
  </div>
  {{/listItems}}
</div>
`;
// Exports
module.exports = code;